import { render, staticRenderFns } from "./ZoomSlider.vue?vue&type=template&id=189361cc&scoped=true&"
import script from "./ZoomSlider.vue?vue&type=script&lang=js&"
export * from "./ZoomSlider.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSlider.vue?vue&type=style&index=0&id=189361cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189361cc",
  null
  
)

export default component.exports